import React, { useEffect, useMemo, useRef, useState } from "react";
import { TreeSelect } from "primereact/treeselect";
import CustomeButton from "../Button";
import "./style.scss";

const CustomMultiSelectDropdown = ({
  groupedOptions = {},
  value = {},
  onChange = () => {},
  applyFilter = () => {},
  deSelectAll = () => {},
  placeholder = "Select Filters",
  filterCount,
  buttonFilter = false,
}) => {
  const treeSelectRef = useRef();
  const [distance, setDistance] = useState(0);
  const divRef = useRef(null);

  useEffect(() => {
    if (buttonFilter) {
      const element = divRef.current;
      if (element) {
        const rect = element.getBoundingClientRect();
        const distanceFromRight = window.innerWidth - rect.right;
        setDistance(distanceFromRight);
      }
    }
  }, []);

  const treeData = useMemo(() => {
    return Object.entries(groupedOptions).map(([group, items]) => {
      const selectedCount = items.filter(
        (item) => value[typeof item === "object" ? item.id : item]?.checked,
      ).length;
      const label = selectedCount ? `${group} (${selectedCount})` : group;

      return {
        key: group,
        label,
        selectable: false,
        children: items.map((item) => ({
          key: typeof item === "object" ? item.id : item,
          label: typeof item === "object" ? item.name : item,
          id: typeof item === "object" ? item.id : item,
          groupKey: group,
          className:
            typeof item === "object"
              ? item.disable
                ? "disable-node pointer-events-none"
                : ""
              : "",
        })),
      };
    });
  }, [groupedOptions, value]);

  const getSelectedLeafKeys = () => {
    const groupKeys = Object.keys(groupedOptions);
    return Object.entries(value)
      .filter(
        ([key, val]) =>
          !groupKeys.includes(key) && val?.checked && !val?.partialChecked,
      )
      .map(([key]) => key);
  };

  const getLabelFromKey = (key) => {
    for (const items of Object.values(groupedOptions)) {
      for (const item of items) {
        const itemKey = typeof item === "object" ? item.id : item;
        if (itemKey === key) {
          return typeof item === "object" ? item.name : item;
        }
      }
    }
    return key;
  };

  return (
    <div
      className={
        buttonFilter
          ? `custom__multiselect_dropdown ${distance < 350 ? "position__left" : ""}`
          : "custom-multiselect"
      }
      ref={divRef}
    >
      {buttonFilter && (
        <CustomeButton
          label={`Filters (${filterCount})`}
          icon="pi pi-filter"
          iconPos="right"
          onClick={() => treeSelectRef.current?.show()}
        />
      )}
      <TreeSelect
        ref={treeSelectRef}
        value={value}
        onChange={(e) => {
          onChange({ value: e.value });
        }}
        options={treeData}
        selectionMode="checkbox"
        display="chip"
        filter
        placeholder={placeholder}
        className="md:w-19rem w-full"
        valueTemplate={() => {
          const selectedLeafKeys = getSelectedLeafKeys();
          return (
            <div className="chip-container">
              {selectedLeafKeys.length ? (
                selectedLeafKeys.map((key) => (
                  <span key={key} className="chip">
                    {getLabelFromKey(key)}
                  </span>
                ))
              ) : (
                <span className="placeholder">{placeholder}</span>
              )}
            </div>
          );
        }}
        panelFooterTemplate={() => (
          <div className="filter__action">
            <CustomeButton
              label="Deselect All"
              className="access-btn"
              onClick={() => {
                deSelectAll();
                treeSelectRef.current?.hide();
              }}
            />
            <CustomeButton
              label="Apply Filters"
              className="access-btn"
              variant="contained"
              onClick={() => {
                applyFilter();
                treeSelectRef.current?.hide();
              }}
            />
          </div>
        )}
        panelClassName="custom-tree-panel"
        dropdownIcon="pi pi-chevron-down"
      />
    </div>
  );
};

export default CustomMultiSelectDropdown;
